export const apiPath = '/v2/requirements';
const actionType = 'REQUIREMENTS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
